import cx from 'classnames';
import { useState } from 'react';
import { Button, ButtonVariants } from '@components/button/Button';
import { errorToast } from '@components/toasts/Toasts';
import { reportAppError } from '@shared/reportAppError';
import type { GuestTag } from 'restaurantAdmin/restaurants/apiHelpers';
import { useRestaurant } from '../../../context/useRestaurant';
import { updateGuestTags } from '../../../guestBook/apiHelpers';
import styles from './GuestTagEditForm.scss';
import { GuestTagCombobox } from '../GuestTagCombobox';

interface GuestTagEditFormProps {
  guestId: string;
  guestTags: GuestTag[];
  onComplete: () => void;
}

export const GuestTagEditForm = ({
  guestId,
  guestTags,
  onComplete,
}: GuestTagEditFormProps) => {
  const { id: restaurantId } = useRestaurant();

  const [value, setValue] = useState<(GuestTag | string)[]>(guestTags);

  const handleOnSave = async () => {
    const tags = value.map((val) =>
      typeof val === 'string'
        ? { id: null, title: val }
        : {
            id: val.id,
            title: val.title,
          },
    );

    try {
      await updateGuestTags({
        guestId,
        restaurantId,
        tags,
      });
      onComplete();
    } catch (e) {
      errorToast({ message: 'Failed to update guest tags' });
      reportAppError(e);
    }
  };

  return (
    <div className={styles.container}>
      <GuestTagCombobox onChange={(v) => setValue(v)} defaultValue={value} />
      <div className={styles.actions}>
        <Button
          className={cx(styles.btn, styles.secondaryBtn)}
          label="Discard"
          onClick={onComplete}
          variant={ButtonVariants.DefaultWhite}
        />
        <Button
          className={styles.btn}
          label="Save"
          onClick={handleOnSave}
          variant={ButtonVariants.Primary}
        />
      </div>
    </div>
  );
};
